let idsCallback: Record<string, NodeJS.Timeout> = {};

export const useDebounce = () => {
  const callbackDebounce = (callback: () => void, id: string, time = 100) => {
    if (idsCallback?.[id]) {
      clearTimeout(idsCallback[id]);
    }
    idsCallback[id] = setTimeout(() => {
      callback();
      delete idsCallback[id];
    }, time);
  };

  const clearCallbacksDebounce = () => {
    Object.keys(idsCallback).forEach((key) => {
      clearTimeout(key);
    });
    idsCallback = {};
  };

  return { callbackDebounce, clearCallbacksDebounce };
};
